module.exports = __webpack_public_path__ + "img/recycle-active.f307e31e.svg";